export const MemWelfareConstant = {
    FEED_REQUEST: 'FEED_MEMWELFARE_REQUEST',
    FEED_SUCCESS: 'FEED_MEMWELFARE_SUCCESS',
    FEED_FAILURE: 'FEED_MEMWELFARE_FAILURE',
    TABS_CHANGES:'TABS_MEMWELFARE_CHANGE'
}
